import axios from "axios";
import { orikamiDomain } from "../urlConst/domainUrl";

const API_URL_GET_USERS = orikamiDomain + "/api/v1/admin/list";

const API_URL_ADD_USER = orikamiDomain + "/api/v1/admin/add";

const API_URL_EDIT_USER = orikamiDomain + "/api/v1/admin/edit";

const API_URL_DELETE_USER = orikamiDomain + "/api/v1/admin/delete";

//   Get User
const getUsers = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.get(API_URL_GET_USERS, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Add User
const addUser = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.post(API_URL_ADD_USER, data, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Edit User
const updateUser = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.put(API_URL_EDIT_USER, data, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

//   Delete User
const deleteUser = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
    data: data,
  };
  const res = await axios.delete(API_URL_DELETE_USER, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

const userService = {
  getUsers,
  addUser,
  updateUser,
  deleteUser,
};

export default userService;
